/* eslint-disable import/no-named-as-default */
import './index.css';
import React from 'react';
import { ConfigProvider as ConfigProvider5 } from 'antd-v5';
import { QueryClient, QueryClientProvider } from 'react-query';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import * as serviceWorker from './serviceWorker';
import store from './core/store';
import LayoutContext from './context/Layout';
import NotificationsContext from './context/Notifications';
import AIAssistantContext from './context/AIAssistantContext';
import SocketContext from './context/SocketContext';
import IntercomContext from './context/IntercomContext';

const queryClient = new QueryClient();

ReactDOM.render(
  <ConfigProvider5
    prefixCls="ant5"
    theme={{
      token: {
        colorPrimary: '#3AA4FC',
      },
      components: {
        Timeline: {
          dotBg: 'transparent',
        },
      },
    }}
  >
    <QueryClientProvider client={queryClient}>
      <Provider store={store}>
        <BrowserRouter>
          <LayoutContext>
            <IntercomContext>
              <SocketContext>
                <NotificationsContext>
                  <AIAssistantContext>
                    <App />
                  </AIAssistantContext>
                </NotificationsContext>
              </SocketContext>
            </IntercomContext>
          </LayoutContext>
        </BrowserRouter>
      </Provider>
    </QueryClientProvider>
  </ConfigProvider5>,
  document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA changed to
// https://github.com/facebook/create-react-app/blob/main/packages/cra-template/template/README.md

serviceWorker.unregister();
